import Captcha from './Captcha';

export default Captcha;



// WEBPACK FOOTER //
// ./scripts/blocks/form/components/Captcha/index.js